import { Box } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { NavigationProvider } from "./shared/contexts/NavigationContext";
import ScrollToTop from "./shared/components/ScrollToTop";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import "./App.css";

interface IRoute {
  path: string;
  element: JSX.Element;
}

const customStyles = {
  mainBox: {
    m: -1,
  },
};

const App = () => {
  const appRoutes: IRoute[] = [
    { path: "/", element: <Home /> },
    { path: "/service/:serviceId", element: <ServiceDetail /> },
    { path: "/about", element: <AboutUsPage /> },
    { path: "/contact", element: <ContactUsPage /> },
  ];

  return (
    <Box sx={customStyles.mainBox}>
      <RecoilRoot>
        <BrowserRouter>
          <NavigationProvider>
            <ScrollToTop />
            <Routes>
              {appRoutes.map(({ element, path }, index) => (
                <Route key={path} path={path} element={element} />
              ))}
            </Routes>
          </NavigationProvider>
        </BrowserRouter>
      </RecoilRoot>
    </Box>
  );
};

export default App;
